var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 17,
    viewBox: "0 0 102 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.482 16.25L89.0049 1.24023C88.7684 0.93107 88.401 0.750019 88.0117 0.75L14.5801 0.75C14.2007 0.75 13.8417 0.922632 13.6045 1.21875L1.56152 16.25L100.482 16.25Z",
    stroke: "url(#paint0_linear_4972_173002)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4972_173002",
    x1: 51,
    y1: 11,
    x2: 51,
    y2: -6.55651e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17B26A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderBottom);
export default __webpack_public_path__ + "static/media/border-bottom.335ff2dbbd994a4ac8b7c2d430729808.svg";
export { ForwardRef as ReactComponent };